var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
// Const variables for use within forms
const errorClass = 'is-invalid';
const recaptchaFieldName = 'g-recaptcha-response';
const emailRegex = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/mi;
const phoneRegex = /^(?!(\n))((\+[0-9]{1,3})|(\([0-9]{1,3}\)))?([\s.-])?(\([0-9]{1,3}\)[\s.-]*)?(([0-9])([-. \t]?)){7,13}$/mi;
const postcodeRegex = /^[a-z]{1,2}\d[a-z\d]?\s*\d[a-z]{2}$/mi;
/**
 * Gets the parent form element if possible for the given field HTMLElement
 * @param field The field related to a form to use as the child when finding the parent form.
 * @returns Null if no parent form exists or a HTMLFormElement if a form is found.
 */
function findParentFormElement(field) {
    let form = null;
    let parentElement = field.parentElement;
    // If the parent element of the current element is null
    // it has no parent and we need to break out the loop
    if (parentElement == null) {
        form = null;
    }
    else if (parentElement.tagName == 'FORM') {
        form = parentElement;
    }
    else {
        form = findParentFormElement(parentElement);
    }
    // return form value
    return form;
}
/**
 * This field is marked as required and so much be evaluated for correct content.
 * @param field The Input Element to be evaluated.
 * @returns A boolean result, true meaning the field passed validation and false meaning validation failed.
 */
function validateRequired(field) {
    let failedValidation = true;
    // Check the value of the field, if its empty then mark the required validation as a failure
    if (field.value === '' || field.value === null || field.value === undefined) {
        failedValidation = false;
    }
    // if the field type is a checkbox update the element type and get the checked state to ensure the field is checked.
    if (field.type === 'checkbox' && !field.checked) {
        failedValidation = false;
    }
    // if the field type is a radio button update the element type and get the checked state to ensure the field is checked.
    if (field.type === 'radio') {
        let typedField = field;
        let anyChecked = typedField.checked;
        if (!anyChecked) {
            let form = findParentFormElement(typedField);
            if (form != null) {
                let fieldName = typedField.name;
                let relatedFields = form.querySelectorAll(`input[name=${fieldName}]`);
                relatedFields.forEach(field => {
                    anyChecked = anyChecked || field.checked;
                });
            }
        }
        if (!anyChecked) {
            failedValidation = false;
        }
    }
    return failedValidation;
}
/**
 * Evaluate the field against the email regex to ensure the field value matches the correct formatting.
 * @param field The Input Element to be evaluated.
 * @returns A boolean result, true meaning the field passed validation and false meaning validation failed.
 */
function validateEmail(field) {
    return emailRegex.test(field.value);
}
/**
 * Evaluate the field against the phone regex to ensure the field value matches the correct formatting.
 * @param field The Input Element to be evaluated.
 * @returns A boolean result, true meaning the field passed validation and false meaning validation failed.
 */
function validatePhone(field) {
    return phoneRegex.test(field.value);
}
/**
 * Evaluate the field against the postcode regex to ensure the field value matches the correct formatting.
 * @param field The Input Element to be evaluated.
 * @returns A boolean result, true meaning the field passed validation and false meaning validation failed.
 */
function validatePostcode(field) {
    return postcodeRegex.test(field.value);
}
/**
 * Field was evaluated against the current rule and found to fail the rule, the field and labels now need to be updated into an error state.
 * @param field The Input Element that failed the latest rule evaluation.
 * @param labels The Input Element's associated labels to be updated into an error state contianing the error message.
 * @param message The error message relating to the recently failed rule.
 */
function evaluationFailed(field, labels, message) {
    // add the error class if present from the field elements
    field.classList.add(errorClass);
    labels.forEach((label) => {
        // add the error message to the fields form flag label if it doesn't already contain it
        if (label.classList.contains(`form-${field.name.toLowerCase()}-flag`) && !label.innerHTML.includes(message)) {
            // @ts-ignore: TS7053
            label.innerHTML += `${message} <br />`;
        }
        // add the error class if present from the label elements
        label.classList.add(errorClass);
    });
}
/**
 * When a rule is satisfied the labels need to be updated to no longer display that error.
 * @param field The Input Element evaluated and found to pass the current rule.
 * @param labels The Labels associated to the Input Element to be updated to no longer contain that rules error.
 * @param message The message associated to the recently passed rule now to be removed if present.
 */
function evaluationSuccess(field, labels, message) {
    labels.forEach((label) => {
        // Remove the validation error message from the label if present
        if (label.classList.contains(`form-${field.name.toLowerCase()}-flag`)) {
            label.innerHTML = label.innerHTML.replace(`${message} <br>`, '');
        }
    });
}
/**
 * All the rules for a given element are satisfied and so the field and related labels should be reset.
 * @param field The Input Element to be reset to a non-errored state.
 * @param labels The Input Elements labels to be reset to a non-errored state.
 */
function evaluationFullSuccess(field, labels) {
    // remove the error class if present from the field element
    field.classList.remove(errorClass);
    if (field.type === 'radio') {
        let form = findParentFormElement(field);
        if (form != null) {
            let fieldName = field.name;
            let relatedFields = form.querySelectorAll(`input[name=${fieldName}]`);
            relatedFields.forEach(relatedField => {
                relatedField.classList.remove(errorClass);
            });
        }
    }
    // Remove Error messages from the fields labels
    clearFieldErrorMessages(field, labels);
    labels.forEach((label) => {
        // remove the error class if present from the label elements
        label.classList.remove(errorClass);
    });
}
/**
 * Clear the fields error messages out and reset error status class.
 * @param field The field that needs its error messages reset.
 * @param labels The labels to be emptied of errors and the error classes
 */
function clearFieldErrorMessages(field, labels) {
    labels.forEach((label) => {
        // if the label is the form flag label empty out the innerhtml removing any error messages
        if (label.classList.contains(`form-${field.name.toLowerCase()}-flag`)) {
            // @ts-ignore: TS7053
            label.innerHTML = null;
        }
    });
}
/**
 * Taking in a field evaluates the fields contents against the rules object producing error class if anything does not pass validation.
 * @param field The Input Element being evaluated.
 * @param rules The rules associated to the fields data.
 * @param messages The related message to each rule to be displayed upon rule failed.
 * @param labels The label elements relating to the field to be updated.
 * @returns Returns a boolean state if the field fully passed validation.
 */
function evaluateField(field, rules, messages, labels) {
    //Set field validation variables for evaluating if input status needs to be reset or updated with other errors
    let failedValidation = false;
    let noValidationFails = true;
    let performRule = true;
    let endValidation = false;
    clearFieldErrorMessages(field, labels);
    // ensure the field isvisible before evaluating it
    if (field.checkVisibility({ visibilityProperty: true })) {
        // loop through each of the rules to do with a field
        for (let rule in rules) {
            if (endValidation) {
                break;
            }
            // reset failed validation flag
            failedValidation = false;
            // @ts-ignore: TS7053
            performRule = rules[rule];
            if (performRule) {
                switch (rule) {
                    case 'required':
                        // if the rule is required and set to true evaluate the field is populated
                        failedValidation = !validateRequired(field);
                        endValidation = failedValidation;
                        break;
                    case 'email':
                        // if the rule is email and set to true evaluate the field is an email
                        failedValidation = !validateEmail(field);
                        break;
                    case 'phone':
                        // if the rule is phone and set to true evaluate the field is a phone
                        failedValidation = !validatePhone(field);
                        break;
                    case 'postcode':
                        // if the rule is phone and set to true evaluate the field is a phone
                        failedValidation = !validatePostcode(field);
                        break;
                    default:
                        console.error(`Unrecognised Rule: ${rule} provided for validating field:`, field);
                        break;
                }
            }
            let message = 'This field failed validation';
            // Get the message relating to the specific rule for adding/ removing from the list
            // If the messages array is not null
            if (messages !== null && messages !== undefined) {
                // Return the rule message or the default message
                // @ts-ignore: TS7053
                message = (messages[rule] !== null && messages[rule] !== undefined ? messages[rule] : message);
            }
            // Validation success
            if (!failedValidation) {
                evaluationSuccess(field, labels, message);
            }
            // Validation failed
            if (failedValidation) {
                // Update NoValidationFails boolean for the field to false
                noValidationFails = false;
                evaluationFailed(field, labels, message);
            }
        }
        // Perform a final validation on the field to check if any field rules failed not included within the explicit checks above
        // such as value too low, value too high, length too long or length too short which are all handled by the browsers built in validation and will be caught by the checkValidity method
        if (!field.validity.valid
            && (field.validity.rangeUnderflow || field.validity.rangeOverflow
                || field.validity.tooShort || field.validity.tooLong)) {
            noValidationFails = false;
            evaluationFailed(field, labels, field.validationMessage);
        }
    }
    // If all the rules are satisfied reset the field and labels states
    if (noValidationFails) {
        evaluationFullSuccess(field, labels);
    }
    // return true if the field passed all validation checks.
    return noValidationFails;
}
/**
 * Clears the reCaptcha error label fields.
 * @param form The form to clear the errors out of.
 */
function clearRecaptchaErrors(form) {
    let recaptchaField = form.querySelector(`[name=\'${recaptchaFieldName}\']`);
    let recaptchaLabel = form.querySelectorAll(`[for=\'${recaptchaFieldName}\']`);
    if (recaptchaField !== null) {
        clearFieldErrorMessages(recaptchaField, recaptchaLabel);
    }
}
/**
 * Runs a single validation against the whole form returning a true or false boolean.
 * @param form The form to be evaluated.
 * @param validationRules The list of rules on which fields to be evaluated and what type of validation is required.
 * @param validationMessages The error messages to be displayed on rule failures.
 * @returns A boolean value true representing all rules successful and form is valid.
 */
function clientValidateForm(form, validationRules, validationMessages = undefined) {
    let formValid = true;
    // Clear out the ReCaptcha error fields
    clearRecaptchaErrors(form);
    for (let fieldID in validationRules) {
        let fieldElements = form.querySelectorAll(`[name=\'${fieldID}\']`);
        let labels = form.querySelectorAll(`[for=\'${fieldID}\']`);
        fieldElements.forEach(fieldElement => {
            if (fieldElement != null || fieldElement != undefined) {
                // Validate Field
                let fieldValid = evaluateField((fieldElement.tagName.toLowerCase() === 'input' ? fieldElement : fieldElement), validationRules[fieldID], (validationMessages !== null && validationMessages !== undefined ? validationMessages[fieldID] : null), labels);
                // Update the formValid boolean by performing an and operation with the current state,
                // will only stay true if all the fields return true signifying they passed all rule checks.
                formValid = formValid && fieldValid;
            }
        });
    }
    return formValid;
}
/**
 * Initializes form validation triggers on the form fields using the provided rules and messages.
 * @param form The HTML Form Element to attach the event listeners to.
 * @param validationRules The Validation rules listing which fields need validating and what types of validations need to be run.
 * @param validationMessages The related validation messages for displaying when validation rules fail.
 */
function clientInitializeFormValidation(form, validationRules, validationMessages = undefined) {
    // For each field listed in the Validation Rules
    for (let fieldID in validationRules) {
        // Get the field element and the related labels to the field
        let fieldElements = form.querySelectorAll(`[name=\'${fieldID}\']`);
        let labels = form.querySelectorAll(`[for=\'${fieldID}\']`);
        fieldElements.forEach(fieldElement => {
            // If the field element is valid attach the listeners
            if (fieldElement != null || fieldElement != undefined) {
                fieldElement.addEventListener("focusout", () => {
                    evaluateField((fieldElement.tagName.toLowerCase() === 'input' ? fieldElement : fieldElement), validationRules[fieldID], (validationMessages !== null && validationMessages !== undefined ? validationMessages[fieldID] : null), labels);
                });
                fieldElement.addEventListener("change", () => {
                    evaluateField((fieldElement.tagName.toLowerCase() === 'input' ? fieldElement : fieldElement), validationRules[fieldID], (validationMessages !== null && validationMessages !== undefined ? validationMessages[fieldID] : null), labels);
                });
            }
        });
    }
}
/**
 * Handle Successful form submissions.
 * @param form The form that was submitted.
 * @returns Redirects the user to the redirect url provided in the form.
 */
function handleSuccess(form_1) {
    return __awaiter(this, arguments, void 0, function* (form, gaEvent = undefined) {
        // If a Google Analytics event is present
        if (gaEvent !== null && gaEvent !== undefined) {
            dataLayer.push(gaEvent);
        }
        // If the redirect field is present on the form
        const redirectField = form.querySelector("input#redirectUrl");
        if (redirectField !== null) {
            // redirect the user
            window.location.assign(redirectField.value);
            return;
        }
        // Get the error text field to populate
        let errorText = form.querySelector('label.form-recaptcha-flag');
        if (errorText !== null) {
            // Add an error explaing the form was successfully submitted but the redirect was missing to avoid confusion.
            errorText.innerHTML = 'Form was submitted successfully but redirect url is missing.';
        }
        return;
    });
}
/**
 * Handle validation errors provided by the forms controller.
 * @param response The response object from the form's controller to be used when populating the error fields.
 * @param form The calling form element used for making the request for populating with errors.
 * @returns Updates the forms labels and fields with the error's sent by the forms controller.
 */
function handleValidationError(response, form) {
    return __awaiter(this, void 0, void 0, function* () {
        let responseJSON = yield response.json();
        // If responseJSON contains a field called errors update responseJSON to be the errors field to keep using following code
        if (responseJSON.errors !== undefined) {
            responseJSON = responseJSON.errors;
        }
        for (let i in responseJSON) {
            // Get each field from the responseJSON array
            let field = responseJSON[i];
            // Create a boolean flag for displaying if the field contains an error field as we will need to parse the error message
            // field not the field itself
            const modelError = field.errors !== undefined;
            // If the field contains an errors field update the field to be the errors field and update the modelError flag
            if (field.errors !== undefined) {
                field = field.errors;
            }
            // If the field has content
            if (field.length > 0) {
                // Target the form fields error span
                const errorField = form.querySelector(`.form-${i.toLowerCase()}-flag`);
                // Get the error text to populate the errorField span either from the field itself or the nested errorMessage field
                let errorText = modelError ? field[0].errorMessage : field[0];
                // If there is more than one error message field in the model append the extra messages to the error text
                if (field.length > 1) {
                    for (let i = 1; i < field.length; i++) {
                        errorText += `${modelError ? field[i].errorMessage : field[i]}<br/>`;
                    }
                }
                // Update the error field span with the error text
                if (errorField !== null) {
                    errorField.innerHTML = errorText;
                    errorField.classList.add(errorClass);
                }
            }
        }
    });
}
export class Forms {
    /**
     * Initializes the form validation on a given form selector with the provided validation rules and messages.
     * @param formSelector The CSS Selector of the form to be validated.
     * @param validationRules The validation rules to be applied to the form fields.
     * @param validationMessages The validation messages to be displayed for each field when validation fails.
     */
    static initializeFormValidation(formSelector, validationRules, validationMessages = undefined, gaEvent = undefined) {
        let forms = document.querySelectorAll(formSelector);
        forms.forEach((form) => {
            // Setup each form with validation listener
            clientInitializeFormValidation(form, validationRules, validationMessages);
            // Add submit event listener to run instal of basic HTML form logic
            form.addEventListener("submit", (e) => __awaiter(this, void 0, void 0, function* () {
                // Stops the form from submitting through normal HTML
                e.preventDefault();
                e.stopPropagation();
                if (e.submitter !== null && e.submitter.disabled === true) {
                    return;
                }
                let submitButtons = form.querySelectorAll("button[type='submit']");
                let buttonInnerHTMLs = [];
                submitButtons.forEach((button) => {
                    buttonInnerHTMLs.push(button.innerHTML);
                    button.disabled = true;
                    button.innerHTML = '<i class="spinner-border"></i>';
                });
                const formValid = clientValidateForm(form, validationRules, validationMessages);
                // If the form is invalid exit out early to avoid unneccicary processing or hangtime
                if (!formValid) {
                    submitButtons.forEach((button) => {
                        var _a;
                        button.disabled = false;
                        button.innerHTML = (_a = buttonInnerHTMLs.shift()) !== null && _a !== void 0 ? _a : '';
                    });
                    return;
                }
                // Form passes client validation
                try {
                    // Send a request to the forms controller
                    const response = yield fetch(form.action, {
                        method: form.method,
                        body: new FormData(form)
                    });
                    // If the request returned a successful response
                    if (response.ok) {
                        handleSuccess(form, gaEvent);
                    }
                    else {
                        // Otherwise
                        handleValidationError(response, form);
                    }
                    submitButtons.forEach((button) => {
                        var _a;
                        button.disabled = false;
                        button.innerHTML = (_a = buttonInnerHTMLs.shift()) !== null && _a !== void 0 ? _a : '';
                    });
                    return;
                }
                catch (_a) {
                    // Something went wrong 
                    console.error('Promise Rejected');
                    submitButtons.forEach((button) => {
                        var _a;
                        button.disabled = false;
                        button.innerHTML = (_a = buttonInnerHTMLs.shift()) !== null && _a !== void 0 ? _a : '';
                    });
                    return;
                }
            }));
        });
    }
}
